import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BOX_SHADOWS, FONTS, ROUTES } from "../constants";
import { LogoNameMainPageScroll } from "../dashboard/Common/LogoNameMainPageScroll";
import { isMobile } from "react-device-detect";

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		container: {
			width: "100vw",
			height: "60px",
			backgroundColor: "white",
			transition: "0.4s",
			position: "fixed",
			boxShadow: BOX_SHADOWS,
			marginTop: "0px",
			zIndex: 1000,
			overflow: "hidden",
		},
		containerInvisible: {
			width: "100vw",
			height: "0px",
			backgroundColor: "white",
			position: "fixed",
			transition: "0.4s",
			boxShadow: BOX_SHADOWS,
			marginTop: "-80px",
			zIndex: 1000,
			overflow: "hidden",
		},
		topBar: {
			display: "flex",
			flexDirection: "row",
			justifyContent: "space-between",
		},
		tryItButtonOut: {
			zIndex: 100,
			display: "flex",
			backgroundColor: "rgb(118, 7, 143)",
			marginTop: "38px",
			"&:hover": {
				backgroundColor: "white",
				borderColor: "rgb(118, 7, 143)",
				color: "rgb(118, 7, 143)",
			},
			transition: "0.2s",
			border: "solid",
			borderColor: "rgb(118, 7, 143)",
			borderRadius: "10px",
			borderWidth: "2px",
			marginRight: isMobile ? "auto" : "110px",
		},
		tryItTextOut: {
			color: "white",
			height: "40px",
			width: isMobile ? "130px" : "160px",
			textAlign: "center",
			fontFamily: FONTS,
			lineHeight: "40px",
			fontSize: isMobile ? "15px" : "18px",
			cursor: "pointer",
			"&:hover": {
				color: "rgb(118, 7, 143)",
			},
			transition: "0.2s",
			fontWeight: "bold",
		},
		topBlockContainer: {
			width: isMobile ? "100%" : "1500px",
			// backgroundColor: "red",
			marginLeft: isMobile ? "5px" : "130px",
			marginRight: isMobile ? "5px" : "auto",
			marginTop: "-20px",
		},
		topBlockBackground: {
			backgroundSize: "100vw 100%",
			height: "700px",
			justifyContent: "center",
			display: "flex",
		},
	});
});

function TryItButtonOutlined() {
	const classes = useStyles();
	return (
		<Link to={ROUTES.data_ingestion} style={{ textDecoration: "none" }}>
			<div className={classes.tryItButtonOut}>
				<div className={classes.tryItTextOut}>GET STARTED</div>
			</div>
		</Link>
	);
}

export function TopBar() {
	const classes = useStyles();

	return (
		<div className={classes.topBar}>
			<LogoNameMainPageScroll></LogoNameMainPageScroll>
			<div
				style={{
					marginTop: "-10px",
				}}
			>
				<TryItButtonOutlined></TryItButtonOutlined>
			</div>
		</div>
	);
}

export function TopBarScroll() {
	const classes = useStyles();
	const [scrollPosition, setScrollPosition] = useState(0);
	const handleScroll = () => {
		const position = window.pageYOffset;
		setScrollPosition(position);
	};

	useEffect(() => {
		window.addEventListener("scroll", handleScroll, { passive: true });
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);
	const topInit = 150;
	return (
		<div>
			<div
				className={
					scrollPosition > topInit
						? classes.container
						: classes.containerInvisible
				}
			>
				<div className={classes.topBlockBackground}>
					<div className={classes.topBlockContainer}>
						<TopBar></TopBar>
					</div>
				</div>
			</div>
		</div>
	);
}
